import {Button, Group, Modal, Text} from '@mantine/core';
import React from 'react';

import ButtonWithDisabledReason from 'ui-library/buttons/ButtonWithDisabledReason';
import ModalFooter from 'ui-library/modals/ModalFooter';

interface ProteinCreationLeaveModalProps {
  downloadDisabledReason: string | null;
  onDownloadCSV: () => void;
  onStay: () => void;
  onLeave: () => void;
}

export default function ProteinCreationLeaveModal({
  downloadDisabledReason,
  onDownloadCSV,
  onStay,
  onLeave,
}: ProteinCreationLeaveModalProps): JSX.Element {
  return (
    <Modal
      title="Leave protein creation?"
      opened={true}
      onClose={onStay}
      size="md"
      closeButtonProps={{'aria-label': 'Close'}}
    >
      <Text size="sm">
        Your progress creating proteins won&apos;t be saved. Download a .csv to continue creating these
        proteins later.
      </Text>
      <ModalFooter>
        <Group position="apart">
          <ButtonWithDisabledReason
            variant="ghost"
            disabledTooltip={downloadDisabledReason}
            onClick={onDownloadCSV}
          >
            Download .csv
          </ButtonWithDisabledReason>
          <Group spacing="sm">
            <Button variant="tertiary" onClick={onStay} data-autofocus={true}>
              Stay on this page
            </Button>
            <Button variant="warn" onClick={onLeave}>
              Leave
            </Button>
          </Group>
        </Group>
      </ModalFooter>
    </Modal>
  );
}
